export enum Color {
  DANGER = 'danger',
  NEUTRAL = 'neutral',
  PRIMARY = 'primary',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export enum CustomColor {
  BLACK = 'black',
  WHITE = 'white',
}

export enum Variant {
  OUTLINED = 'outlined',
  PLAIN = 'plain',
  SOFT = 'soft',
  SOLID = 'solid',
}

export enum SkeletonVariant {
  CIRCULAR = 'circular',
  RECTANGULAR = 'rectangular',
  TEXT = 'text',
}

export enum Size {
  LG = 'lg',
  MD = 'md',
  SM = 'sm',
}

export enum Orientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum Direction {
  COLUMN = 'column',
  ROW = 'row',
}

export enum Level {
  BODY_LG = 'body-lg',
  BODY_MD = 'body-md',
  BODY_SM = 'body-sm',
  BODY_XS = 'body-xs',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  TITLE_LG = 'title-lg',
  TITLE_MD = 'title-md',
  TITLE_SM = 'title-sm',
}

export const enum TooltipPosition {
  BOTTOM = 'bottom',
  BOTTOM_END = 'bottom-end',
  BOTTOM_START = 'bottom-start',
  LEFT = 'left',
  LEFT_END = 'left-end',
  LEFT_START = 'left-start',
  RIGHT = 'right',
  RIGHT_END = 'right-end',
  RIGHT_START = 'right-start',
  TOP = 'top',
  TOP_END = 'top-end',
  TOP_START = 'top-start',
}

export const enum ModeType {
  DARK = 'dark',
  LIGHT = 'light',
}

export const enum DecoratorPosition {
  END = 'end',
  START = 'start',
}
